<div class="chart">
	<canvas
		baseChart
		class="ae"
		[data]="chartData"
		[options]="chartOptions"
		[plugins]="chartPlugins"
		[type]="chartType"
	></canvas>
</div>
